// Global components registration

import './form';
import './misc';
